import memoizeOne from 'react-utils/memoizeOne';
import { getProjectName } from '../../../common/utils';
export const getQueryParams = memoizeOne(() => {
  const hostAppName = encodeURIComponent(getProjectName());
  return {
    hostAppName
  };
});